import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '@/lib/auth';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { loading, user, operator } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-espresso-deep text-cream">
        <p className="font-body text-sm uppercase tracking-[0.3em] text-gold-soft">Loading…</p>
      </div>
    );
  }
  if (!user || !operator) return <Navigate to="/admin-login" replace />;
  return <>{children}</>;
}
